import { ptBR } from './pt-BR';

// Simple translation hook
// In a real app, you might use i18next or react-intl
export const useTranslation = () => {
  const t = (key) => {
    const keys = key.split('.');
    let value = ptBR;
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value || key;
  };

  return { t };
};

export default useTranslation;
